module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p10",
      "title": "10"
    }
  }, [_c('h1', {
    staticClass: "chaptername",
    attrs: {
      "id": "AA2"
    }
  }, [_c('span', {
    staticClass: "line_top"
  }, [_vm._v("chapter one")])]), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle"
  }, [_vm._v("Breakfast & Brunch")]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p013#chocolate_cherry_bread"
    }
  }, [_vm._v("Chocolate-Cherry Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p014#monkey_bread"
    }
  }, [_vm._v("Monkey Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p017#five_grain_buttermilk_cranberry_bread"
    }
  }, [_vm._v("Five-Grain Buttermilk-Cranberry Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p018#the_ultimate_pancakes"
    }
  }, [_vm._v("The Ultimate Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p021#upside_down_banana_walnut_french_toast"
    }
  }, [_vm._v("Upside-Down Banana-Walnut French Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p022#apricot_stuffed_french_toast"
    }
  }, [_vm._v("Apricot-Stuffed French Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p024#caramel_sticky_rolls"
    }
  }, [_vm._v("Caramel Sticky Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p027#frozen_blueberry_breakfast_bars"
    }
  }, [_vm._v("Frozen Blueberry Breakfast Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p028#apple_crisp_refrigerator_oatmeal"
    }
  }, [_vm._v("Apple Crisp Refrigerator Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p031#make_it_your_own_oatmeal"
    }
  }, [_vm._v("Make-It-Your-Own Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p032#cheesy_sausage_and_egg_bake"
    }
  }, [_vm._v("Cheesy Sausage and Egg Bake")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p035#spinach_pesto_egg_bakes"
    }
  }, [_vm._v("Spinach-Pesto Egg Bakes")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p036#impossibly_easy_mini_breakfast_sausage_pies"
    }
  }, [_vm._v("Impossibly Easy Mini Breakfast Sausage Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p039#ham_and_swiss_breakfast_hand_pies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham and Swiss Breakfast Hand Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p040#sausage_wrapped_stuffed_chiles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sausage-Wrapped Stuffed Chiles")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p041#egg_and_sausage_breakfast_ring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egg and Sausage Breakfast Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p042#smoked_sausage_spinach_pie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Sausage Spinach Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p045#bacon_and_hash_brown_egg_bake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon and Hash Brown Egg Bake")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p046#chicken_fajita_strata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Fajita Strata")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p051#fruity_green_smoothies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruity Green Smoothies")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p052#skinny_tropical_smoothies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skinny Tropical Smoothies")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0b2fc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p010.vue
// module id = 81
// module chunks = 0